import { Badge, Breadcrumb, Button, Calendar, Col, Collapse, DatePicker, Divider, Drawer, Dropdown, Flex, Form, Input, Layout, notification, Popconfirm, Row, Select, Space, Table, Tag, theme, Tooltip } from 'antd';
import {
  SendOutlined,
  MoreOutlined,
  MessageOutlined,
  UnlockOutlined,
  EyeOutlined,
  LockOutlined,
  EditOutlined,
  DeleteOutlined
} from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react';
import MyResponse from './MyResponse';
import CommitteeAPI from '../../../restAPI/CommitteeAPI';
import { useDispatch, useSelector } from 'react-redux';
import CalendarDataAPI from '../../../restAPI/CalendarDataAPI';
import dayjs from 'dayjs';
import { actionStateCapture, agendaCapture, agendaIDCapture, committeeCapture, commonInformationCapture, generalInformationCapture, initialGeneralInformationCapture, screenEnded, screenStart } from '../../../redux/slices/meetingSlice';
import NewMeetingDrawer from '../../../helperComponents/CreateNewMeeting/NewMeetingDrawer';
import moment from 'moment-timezone';
import MeetingAPI from '../../../restAPI/MeetingAPI';
import { COLOR } from '../../../theme/constant';
import useCurrentCompany from '../../../hooks/useCurrentCompany';

const { Search } = Input;
const { Header, Sider, Content } = Layout;

export default function MyEvents(props) {
  const dispatch = useDispatch();
  const { companyId, token, role, userCompany } = useSelector(state => state.auth);
  const {
    token: { colorBgContainer, borderRadiusLG, colorSuccess, colorWarning },
  } = theme.useToken();

  const [current, setCurrent] = useState(0);
  const [value2, setValue2] = useState('on');
  const [actionState, setActionState] = useState('add');
  const [selectedMeetingDetails, setSelectedMeetingDetails] = useState(null);
  const [api, contextHolder] = notification.useNotification();  
  const currentCompanyInfo = useCurrentCompany();
  const [originalDataObject, setOriginalDataObject] = useState({});
  const [isRecurring, setIsRecurring] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [openNewMeetingDrawer, setOpenNewMeetingDrawer] = useState(false);
  const [isPrevClickedToGeneral, setIsPrevClickedToGeneral] = useState(false);
  const [isPrevClickedToCommittee, setIsPrevClickedToCommittee] = useState(false);
  const [selectedDays, setSelectedDays] = useState([]);
  const [tempDateValue, setTempDateValue] = useState(() => dayjs());

  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement
    });
  };

 
  const handleDropdownVisibleChange = (visible) => {
    setDropdownVisible(visible);
  };

  const handlePopconfirmOpen = (e) => {
    e.stopPropagation();
  };

  const handlePopconfirmClose = () => {
    setDropdownVisible(false);
  };

  const showNewMeetingDrawer = () => {
    setOpenNewMeetingDrawer(true);
  };
  const onCloseNewMeetingDrawer = () => {
    setOpenNewMeetingDrawer(false);
    dispatch(screenEnded());
    setActionState('add');
    setIsRecurring(false);
    setSelectedDays([]);
    setValue2('on');
    setCurrent(0);
    setIsPrevClickedToGeneral(false);
    setIsPrevClickedToCommittee(false);
    props.getMeetingsByDate();
  };

  const getCommitteeInfoForMeeting = async (actionState = 'add') => {
    if (!props.committeeId) return;

    const {
      info: { startDate, name: meetingName },
      participant: { member, _id: participantId },
      committeeId
    } = props.meetingFullData;

    // const checkDateToHandleClick = moment(startDate).isSameOrAfter(moment(), 'minutes');
    // const checkDateToHandleClick = moment(props.fullMeetingDetails.info.startDate).isSameOrAfter(moment().startOf('day'), 'minutes');
    const checkDateToHandleClick = moment(startDate).isSameOrAfter(moment().startOf('day'), 'minutes');

    if (!checkDateToHandleClick && actionState === 'edit') {
      openNotificationWithIcon('error', 'Meeting edit failed', `You can't edit previous meetings.`, 'bottomLeft');
      return;
    }

    if (actionState === 'view') {
      await getSingleMeetingInforByIdAndDate(actionState);
    } else {
      try {
        const response = await CommitteeAPI.getCommitteeById(committeeId, companyId, token);
        if (response.status === 200) {
          const committeeData = response.data.data;
          const isUserInCommittee = [committeeData.secretaryId, committeeData.assistantSecretaryId].includes(currentCompanyInfo.userDetailsId);

          if (isUserInCommittee) {
            await getSingleMeetingInforByIdAndDate(actionState);
          } else {
            openNotificationWithIcon('error', 'Unauthorized', "You don't have the permission to edit a meeting.", 'bottomLeft');
          }
        }
      } catch (error) {
        if (error.response) {
          openNotificationWithIcon('error', 'Unauthorized', `${error.response.data}`, 'bottomLeft');
        } else {
          openNotificationWithIcon('error', 'Failed', `Meeting edit failed`, 'bottomLeft');
        }
        console.log('getCommitteeInfoForMeeting in calendar error ', error);
      }
    }
  };

  const getSingleMeetingInforByIdAndDate = async (actionState) => {
    const { meetingId, meetingDate, originalDate } = props;
    if (!meetingId || !meetingDate || !originalDate) return;

    try {
      let response = null;
      if (actionState === 'view') {
        response = await CalendarDataAPI.getMeetingsByIdAndDateForMeetingView(
          meetingDate, meetingId, dayjs(originalDate), companyId, token
        )
      } else if (actionState === 'edit') {
        response = await CalendarDataAPI.getMeetingsByIdAndDateForMeetingUpdate(
          meetingDate, meetingId, dayjs(originalDate), companyId, token
        )
      } else if (actionState === 'editPaper') {
        response = await CalendarDataAPI.getMeetingsByIdAndDateForAgendaUpdate(
          meetingDate, meetingId, dayjs(originalDate), companyId, token
        )
      }

      if (response) {
        console.log('meeting details :', response);        
        setSelectedMeetingDetails(response.data);
        setActionState(actionState);
        const { info, held, recurrence, participant, committeeType, committee, agenda, minute } = response.data.meeting;
        dispatch(screenStart());

        let generalInformation = null;

        if (actionState !== 'editPaper') {
          generalInformation = {
            info: {
              name: info.name,
            },
            schedule: {
              startDate: dayjs(info.startDate).toISOString(),
              endDate: dayjs(info.endDate).toISOString(),
            },
            held: {
              type: held.type,
              physical: {
                location: held?.physical?.location || '',
                room: held.physical?.room || ''
              },
              online: held.type === 'online' || held.type === 'hybrid' ? held.online.service : ''
            },
            recurrence: {
              status: recurrence.status,
              repeatEvery: recurrence.status ? {
                occurrence: recurrence?.repeatEvery?.occurrence || '',
                type: recurrence?.repeatEvery?.type || '',
                // dayOfWeek: recurrence?.repeatEvery?.type === 'weekly' ? recurrence?.repeatEvery?.dayOfWeek.map(Number).filter(value => !isNaN(value)).sort((a, b) => a - b) : [] || []
                dayOfWeek: recurrence?.repeatEvery?.type === 'weekly' && Array.isArray(recurrence?.repeatEvery?.dayOfWeek)
                  ? recurrence?.repeatEvery?.dayOfWeek.map(Number).filter(value => !isNaN(value)).sort((a, b) => a - b)
                  : []
              } : {},
              repeatEnd: {
                type: recurrence.status ? recurrence?.repeatEnd?.type : "on",
                onDate: recurrence.status && recurrence?.repeatEnd?.type === 'on' ? recurrence?.repeatEnd?.onDate : null,
                afterOccurrence: recurrence.status && recurrence?.repeatEnd?.type === 'after' ? recurrence?.repeatEnd?.afterOccurrence : null,
              }
            }
          };
        }
        

        const meetingCommonInfo = {
          meetingId: meetingId,
          meetingDate: meetingDate,
          originalDate: originalDate,
          originalUserDetailsId: participant.belong.originalUserDetailsId,
          secretaryId: committee?.secretaryId || null,
          assistantSecretaryId: committee?.assistantSecretaryId || null,
          meetingdateAndTime: actionState === 'view' ? dayjs(info.endDate).toISOString() : null,
          minute: actionState === 'view' ? minute : null,
          info: actionState === 'view' ? info : null, 
          pdfMeetingDate:response.data.meetingDate,
          pdfOriginalMeetingDate:response.data.originalDate
        };

        const committeeMembersList = participant.members && participant.members.length > 0
          ? participant.members.map(member => (
            {
              userDetailsId: member._id,
              name: member.detail?.name || '',
              branch: member.detail?.branch?.name || '',
              designation: member.detail.designation,
              attendance: member.data.attendance,
              rsvp: member?.data?.attendance === "mandatory" ? "Yes" : member.data.rsvp.type,
              isDeletable: false,
              isCommitteeMember: member?.data?.isCommitteeMember || false,
            }))
          : [];

        const committeeInformation = {
          participant: {
            committeeType: committeeType ? committeeType?._id : null,
            committeeId: committee?._id || null,
            committeeTypeName: committeeType?.name || null,
            committeeName: committee?.name || null,
            secretaryId: committee?.secretaryId || null,
            assistantSecretaryId: committee?.assistantSecretaryId || null,
            members: committeeMembersList,
          }
        };

        const mapAttachments = (attachments) => {
          return attachments.length > 0
            ? attachments.map((single) => {
              const isPdf = single.filePath
                ? single.filePath.split('.').pop().toLowerCase() === 'pdf'
                : false;
              const eSignatureRequestList =
                single.eSignature && single.eSignature.length > 0
                  ? single.eSignature
                    .filter((singleRequest) => singleRequest.isRequested)
                    .map((singleRequest) => singleRequest.userDetailsId)
                  : [];

              return {
                _id: single._id,
                key: single._id,
                id: single._id,
                name: single.name,
                created: single.timestamp,
                file: single.filePath,
                fileName: single.fileName || 'N/A',
                comment: single.comment,
                shareWith: single.shareWith,
                eSignature: {
                  members: eSignatureRequestList,
                },
                signatureRequestList: single.eSignature,
                // voting: single.voting,
                voting: {
                  ...single.voting,
                  end: {
                    ...single.voting.end,
                    customDate: single.voting.end?.date || null, // Wrapping date inside customDate
                  },
                },
                isPdf: isPdf,
                isAddedToDB: true,
                order: single.order,
                annotation: single.annotation || []
              };
            })
            : [];
        };

        if (actionState !== 'edit') {
          const mappedAgenda = ['editPaper', 'view'].includes(actionState) ? {
            _id: agenda._id,
            categories: agenda.categories.map((category) => ({
              _id: category._id,
              id: category._id,
              isAddedToDB: true,
              order: category.order || 1,
              categoryId: category._id,
              categoryName: category.name,
              items: category.items.map((item) => ({
                _id: item._id,
                id: item._id,
                isAddedToDB: true,
                paperName: item.name,
                name: item.name,
                order: item.order,
                code: item.code,
                paperCode: item.code,
                comment: item.comment,
                attachments: mapAttachments(item.attachments),
                status: item.status
              }))
            }))
          } : {}
          dispatch(agendaCapture(mappedAgenda))
        }
        dispatch(agendaIDCapture(agenda?._id));
        dispatch(generalInformationCapture(generalInformation));
        dispatch(initialGeneralInformationCapture(generalInformation));
        dispatch(commonInformationCapture(meetingCommonInfo));
        dispatch(committeeCapture(committeeInformation));

        const originalDataObject = {
          meetingDate,
          originalDate,
          ...generalInformation,
          ...committeeInformation,
        };
        // console.log('originalDataObject :', originalDataObject)
        setOriginalDataObject(originalDataObject);

        showNewMeetingDrawer();
      }
    } catch (error) {
      openNotificationWithIcon('error', 'Process failed', `Something went wrong.`, 'bottomLeft');
      console.error("getMeetingsByDateAndId error:", error);
    }
  };

  const handleChangeMeetingState = async (changeState, scope = 'following') => {
    const { _id: meetingId, originalDate } = props.meetingFullData;

    let payload = {
      scope: scope,
      action: changeState === 'inactive' ? 'add' : 'remove',
      originalDate: originalDate
    };

    try {
      const response = await MeetingAPI.cancelMeeting(meetingId, payload, companyId, token);
      if (response.status === 200) {
        openNotificationWithIcon('success', 'Successful', `Meeting ${changeState} successful.`, 'bottomLeft');
        props.getMeetingsByDate();
      } else {
        openNotificationWithIcon('error', 'Failed', `Meeting status change failed`, 'bottomLeft');
      }
    } catch (error) {
      if (error.response) {
        openNotificationWithIcon('error', 'Failed', `${error.response.data}`, 'bottomLeft');
      } else {
        openNotificationWithIcon('error', 'Failed', `Meeting status change failed`, 'bottomLeft');
      }
      console.log('Error in handleChangeMeetingState : ', error);
    }
  };

  const handleDeleteMeeting = async () => {
    const { _id: meetingId, originalDate } = props.meetingFullData;
    let payload = {
      scope: 'this',
      originalDate: originalDate
    };

    try {
      const response = await MeetingAPI.deleteSingleMeeting(meetingId, payload, companyId, token);
      if (response.status === 200) {
        openNotificationWithIcon('success', 'Successful', `Meeting deleted successful.`, 'bottomLeft');
        props.getMeetingsByDate();
      }
      else {
        openNotificationWithIcon('error', 'Failed', `Meeting delete failed`, 'bottomLeft');
      }
    } catch (error) {
      if (error.response) {
        openNotificationWithIcon('error', 'Failed', `${error.response.data}`, 'bottomLeft');
      } else {
        openNotificationWithIcon('error', 'Failed', `Meeting delete failed`, 'bottomLeft');
      }
      console.log('Error in delete meeting :', error);
    }
  };

  return (
    <>
      <Badge.Ribbon 
        text={props.meetingStatus === "unpublish" ? props.meetingStatus.charAt(0).toUpperCase() + props.meetingStatus.slice(1)
                : props.meetingStatus === 'archive' ? props.meetingStatus.charAt(0).toUpperCase() + props.meetingStatus.slice(1)
                : props.meetingStatus === 'held' ? "Meeting Held" 
                : props.meetingStatus === 'minutes' ? "Meeting Minutes Updated"
              : props.status
        } 
        color={
          props.meetingStatus === 'unpublish' ? 'gray' :
            props.meetingStatus === 'held' ? colorWarning :
            props.meetingStatus === 'archive' ? COLOR.alizarin500 :
            props.meetingStatus === 'minutes' ? COLOR.peterRiver500 :
            props.meetingStatus === 'publish' ? (
              props.status === 'RSVP' ? 'red' :
              props.status === 'Yes' ? colorSuccess :
              props.status === 'No' ? 'geekblue' :
              'gold'
            ) :
            'gray'
        }
      >
        <div style={{
          padding: "16px 12px",
          background: colorBgContainer,
          borderRadius: borderRadiusLG,
          marginBottom: 8
        }}>
          <Flex justify='space-between' align='center' gap={16}>
            <Flex justify='start-flex' align='center' gap={16}>
              <Badge color={
                props.meetingStatus === 'unpublish' ? 'gray' :
                props.meetingStatus === 'held' ? colorWarning :
                props.meetingStatus === 'archive' ? COLOR.alizarin500 :
                props.meetingStatus === 'minutes' ? COLOR.peterRiver500 :
                props.meetingStatus === 'publish' ? (
                  props.status === 'RSVP' ? 'red' :
                  props.status === 'Yes' ? colorSuccess :
                  props.status === 'No' ? 'geekblue' :
                  'gold'
                ) :
                'gray'
              } />
              <Content>
                <p style={{width:'500px', wordBreak:'break-word', whiteSpace: 'pre-line', overflowWrap: 'anywhere', marginBottom:'0px'}}>{props.name} </p>
                  <span style={{ fontSize: 12,lineBreak:'normal',width:'100%' }}>{props.date} | {props.time}</span>
                 
              </Content>
            </Flex>
            {/* Task 12648*/}
            <Tooltip title="View">
              <Button
              style={{marginTop:'28px',minWidth:'32px'}}
                type="primary"
                icon={<EyeOutlined />}
                // size='small'
                onClick={() => {
                  getSingleMeetingInforByIdAndDate('view');
                  dispatch(actionStateCapture('view'));
                }}
              />
            </Tooltip>


            {/* <Dropdown
              menu={{
                items
              }}
              trigger={['click']}
              open={dropdownVisible}
              onOpenChange={handleDropdownVisibleChange}
            >
              <Button type='link' icon={<MoreOutlined />} />
            </Dropdown> */}
          </Flex>
          {/* <>
            <Divider />
            <MyResponse
              meetingFullData={props.meetingFullData}
              getMeetingsByDate={props.getMeetingsByDate}
              meetingDate={props.meetingDate}
              actionStep={props.status === 'RSVP' ? 'add' : 'edit'}
              attendanceStatus={props.status}
            />
          </> */}
        </div>
      </Badge.Ribbon>
      {contextHolder}
      
      <NewMeetingDrawer
        openDrawer={openNewMeetingDrawer}
        closeDrawer={onCloseNewMeetingDrawer}
        current={current}
        setCurrent={setCurrent}
        actionState={actionState}
        setActionState={setActionState}
        selectedDays={selectedDays}
        setSelectedDays={setSelectedDays}
        isPrevClickedToGeneral={isPrevClickedToGeneral}
        isPrevClickedToCommittee={isPrevClickedToCommittee}
        setIsPrevClickedToGeneral={setIsPrevClickedToGeneral}
        setIsPrevClickedToCommittee={setIsPrevClickedToCommittee}
        isRecurring={isRecurring}
        setIsRecurring={setIsRecurring}
        value2={value2}
        setValue2={setValue2}
        originalDataObject={originalDataObject}
        selectedDate={props.selectedDate}
        setSelectedDate={setTempDateValue}
        selectedMeetinId={props.meetingId}
        meetingDate={props.meetingDate}
        originalDate={props.originalDate}
        openNotificationWithIconf={openNotificationWithIcon}
      />
    </>
  );
}